module.exports = __webpack_public_path__ + "img/paypal.8d689c3c.png";